// @generated by protoc-gen-es v1.6.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/chat/quick_form.proto (package qliq_protobuf.chat, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { LocalizedEntity } from "../localized_entity_pb.ts";
import { MappedModelType } from "./mapped_model_type_pb.ts";
import { SubmittedFormWorkflow } from "../submitted_form_workflow_pb.ts";
import { ButtonAttribute } from "../button_attribute_pb.ts";

/**
 * @generated from message qliq_protobuf.chat.QuickForm
 */
export class QuickForm extends Message<QuickForm> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * @generated from field: bool can_repeat = 3;
   */
  canRepeat = false;

  /**
   * @generated from field: repeated qliq_protobuf.LocalizedEntity name = 4;
   */
  name: LocalizedEntity[] = [];

  /**
   * @generated from field: string email_subject = 5;
   */
  emailSubject = "";

  /**
   * @generated from field: bool is_email_enabled = 6;
   */
  isEmailEnabled = false;

  /**
   * @generated from field: repeated string email_addresses = 7;
   */
  emailAddresses: string[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.chat.QuickForm.Item items = 8;
   */
  items: QuickForm_Item[] = [];

  /**
   * @generated from field: qliq_protobuf.chat.QuickForm.FieldConditionsSet field_conditions_set = 9;
   */
  fieldConditionsSet?: QuickForm_FieldConditionsSet;

  /**
   * @generated from field: repeated qliq_protobuf.chat.QuickForm.WebhookMapping webhook_mappings = 10;
   */
  webhookMappings: QuickForm_WebhookMapping[] = [];

  /**
   * @generated from field: optional qliq_protobuf.chat.MappedModelType mapped_model = 11;
   */
  mappedModel?: MappedModelType;

  /**
   * @generated from field: bool collect_data = 12;
   */
  collectData = false;

  /**
   * @generated from field: qliq_protobuf.SubmittedFormWorkflow submitted_form_workflow = 13;
   */
  submittedFormWorkflow?: SubmittedFormWorkflow;

  /**
   * @generated from field: repeated qliq_protobuf.chat.QuickForm.EmrGroupConnection emr_group_connections = 14;
   */
  emrGroupConnections: QuickForm_EmrGroupConnection[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.chat.QuickForm.WorkflowOptionsByEmr workflow_options_by_emrs = 15;
   */
  workflowOptionsByEmrs: QuickForm_WorkflowOptionsByEmr[] = [];

  /**
   * @generated from field: qliq_protobuf.ButtonAttribute button_attribute = 16;
   */
  buttonAttribute?: ButtonAttribute;

  constructor(data?: PartialMessage<QuickForm>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "can_repeat", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "name", kind: "message", T: LocalizedEntity, repeated: true },
    { no: 5, name: "email_subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_email_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "email_addresses", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "items", kind: "message", T: QuickForm_Item, repeated: true },
    { no: 9, name: "field_conditions_set", kind: "message", T: QuickForm_FieldConditionsSet },
    { no: 10, name: "webhook_mappings", kind: "message", T: QuickForm_WebhookMapping, repeated: true },
    { no: 11, name: "mapped_model", kind: "enum", T: proto3.getEnumType(MappedModelType), opt: true },
    { no: 12, name: "collect_data", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "submitted_form_workflow", kind: "message", T: SubmittedFormWorkflow },
    { no: 14, name: "emr_group_connections", kind: "message", T: QuickForm_EmrGroupConnection, repeated: true },
    { no: 15, name: "workflow_options_by_emrs", kind: "message", T: QuickForm_WorkflowOptionsByEmr, repeated: true },
    { no: 16, name: "button_attribute", kind: "message", T: ButtonAttribute },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm {
    return new QuickForm().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm {
    return new QuickForm().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm {
    return new QuickForm().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm | PlainMessage<QuickForm> | undefined, b: QuickForm | PlainMessage<QuickForm> | undefined): boolean {
    return proto3.util.equals(QuickForm, a, b);
  }
}

/**
 * @generated from enum qliq_protobuf.chat.QuickForm.FieldType
 */
export enum QuickForm_FieldType {
  /**
   * @generated from enum value: HTML_TEXT = 0;
   */
  HTML_TEXT = 0,

  /**
   * @generated from enum value: HTML_NUMBER = 1;
   */
  HTML_NUMBER = 1,

  /**
   * @generated from enum value: DATE = 2;
   */
  DATE = 2,

  /**
   * @generated from enum value: HTML_SELECT = 3;
   */
  HTML_SELECT = 3,

  /**
   * @generated from enum value: HTML_RADIO = 4;
   */
  HTML_RADIO = 4,

  /**
   * @generated from enum value: HTML_CHECKBOX = 5;
   */
  HTML_CHECKBOX = 5,

  /**
   * @generated from enum value: EMAIL = 6;
   */
  EMAIL = 6,

  /**
   * @generated from enum value: PHONE_NUMBER = 7;
   */
  PHONE_NUMBER = 7,

  /**
   * @generated from enum value: SSN = 8;
   */
  SSN = 8,

  /**
   * @generated from enum value: DRIVERS_LICENSE = 9;
   */
  DRIVERS_LICENSE = 9,

  /**
   * @generated from enum value: WEIGHT = 10;
   */
  WEIGHT = 10,

  /**
   * @generated from enum value: FREQUENCY = 11;
   */
  FREQUENCY = 11,

  /**
   * @generated from enum value: DOSAGE = 12;
   */
  DOSAGE = 12,

  /**
   * @generated from enum value: MEDICINE_NDC = 13;
   */
  MEDICINE_NDC = 13,

  /**
   * @generated from enum value: SIGNATURE = 14;
   */
  SIGNATURE = 14,

  /**
   * @generated from enum value: HTML_TIME = 15;
   */
  HTML_TIME = 15,

  /**
   * @generated from enum value: DATETIME = 16;
   */
  DATETIME = 16,

  /**
   * @generated from enum value: BLOOD_PRESSURE = 17;
   */
  BLOOD_PRESSURE = 17,

  /**
   * @generated from enum value: RATINGS = 18;
   */
  RATINGS = 18,

  /**
   * @generated from enum value: BOOLEAN = 19;
   */
  BOOLEAN = 19,

  /**
   * @generated from enum value: CHECKLIST = 20;
   */
  CHECKLIST = 20,

  /**
   * @generated from enum value: NOTICE = 21;
   */
  NOTICE = 21,

  /**
   * @generated from enum value: FILE = 22;
   */
  FILE = 22,

  /**
   * @generated from enum value: RADIO_BUTTONS = 23;
   */
  RADIO_BUTTONS = 23,

  /**
   * @generated from enum value: ADDRESS_FIELD = 24;
   */
  ADDRESS_FIELD = 24,

  /**
   * @generated from enum value: PAIN_SCALE = 25;
   */
  PAIN_SCALE = 25,

  /**
   * @generated from enum value: MARKDOWN = 26;
   */
  MARKDOWN = 26,
}
// Retrieve enum metadata with: proto3.getEnumType(QuickForm_FieldType)
proto3.util.setEnumType(QuickForm_FieldType, "qliq_protobuf.chat.QuickForm.FieldType", [
  { no: 0, name: "HTML_TEXT" },
  { no: 1, name: "HTML_NUMBER" },
  { no: 2, name: "DATE" },
  { no: 3, name: "HTML_SELECT" },
  { no: 4, name: "HTML_RADIO" },
  { no: 5, name: "HTML_CHECKBOX" },
  { no: 6, name: "EMAIL" },
  { no: 7, name: "PHONE_NUMBER" },
  { no: 8, name: "SSN" },
  { no: 9, name: "DRIVERS_LICENSE" },
  { no: 10, name: "WEIGHT" },
  { no: 11, name: "FREQUENCY" },
  { no: 12, name: "DOSAGE" },
  { no: 13, name: "MEDICINE_NDC" },
  { no: 14, name: "SIGNATURE" },
  { no: 15, name: "HTML_TIME" },
  { no: 16, name: "DATETIME" },
  { no: 17, name: "BLOOD_PRESSURE" },
  { no: 18, name: "RATINGS" },
  { no: 19, name: "BOOLEAN" },
  { no: 20, name: "CHECKLIST" },
  { no: 21, name: "NOTICE" },
  { no: 22, name: "FILE" },
  { no: 23, name: "RADIO_BUTTONS" },
  { no: 24, name: "ADDRESS_FIELD" },
  { no: 25, name: "PAIN_SCALE" },
  { no: 26, name: "MARKDOWN" },
]);

/**
 * @generated from message qliq_protobuf.chat.QuickForm.FieldConditionsSet
 */
export class QuickForm_FieldConditionsSet extends Message<QuickForm_FieldConditionsSet> {
  /**
   * @generated from field: optional qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition is_visible = 1;
   */
  isVisible?: QuickForm_FieldConditionsSet_FieldCondition;

  /**
   * @generated from field: optional qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition is_enabled = 2;
   */
  isEnabled?: QuickForm_FieldConditionsSet_FieldCondition;

  /**
   * @generated from field: optional qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition is_checked = 3;
   */
  isChecked?: QuickForm_FieldConditionsSet_FieldCondition;

  constructor(data?: PartialMessage<QuickForm_FieldConditionsSet>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.FieldConditionsSet";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_visible", kind: "message", T: QuickForm_FieldConditionsSet_FieldCondition, opt: true },
    { no: 2, name: "is_enabled", kind: "message", T: QuickForm_FieldConditionsSet_FieldCondition, opt: true },
    { no: 3, name: "is_checked", kind: "message", T: QuickForm_FieldConditionsSet_FieldCondition, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_FieldConditionsSet {
    return new QuickForm_FieldConditionsSet().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_FieldConditionsSet {
    return new QuickForm_FieldConditionsSet().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_FieldConditionsSet {
    return new QuickForm_FieldConditionsSet().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_FieldConditionsSet | PlainMessage<QuickForm_FieldConditionsSet> | undefined, b: QuickForm_FieldConditionsSet | PlainMessage<QuickForm_FieldConditionsSet> | undefined): boolean {
    return proto3.util.equals(QuickForm_FieldConditionsSet, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition
 */
export class QuickForm_FieldConditionsSet_FieldCondition extends Message<QuickForm_FieldConditionsSet_FieldCondition> {
  /**
   * @generated from field: string conditional_operator = 1;
   */
  conditionalOperator = "";

  /**
   * @generated from oneof qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition.condition_payload
   */
  conditionPayload: {
    /**
     * @generated from field: bool conditions_evaluation_result = 2;
     */
    value: boolean;
    case: "conditionsEvaluationResult";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition.ConditionsData conditions_data = 3;
     */
    value: QuickForm_FieldConditionsSet_FieldCondition_ConditionsData;
    case: "conditionsData";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<QuickForm_FieldConditionsSet_FieldCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conditional_operator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "conditions_evaluation_result", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "condition_payload" },
    { no: 3, name: "conditions_data", kind: "message", T: QuickForm_FieldConditionsSet_FieldCondition_ConditionsData, oneof: "condition_payload" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_FieldConditionsSet_FieldCondition {
    return new QuickForm_FieldConditionsSet_FieldCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_FieldConditionsSet_FieldCondition {
    return new QuickForm_FieldConditionsSet_FieldCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_FieldConditionsSet_FieldCondition {
    return new QuickForm_FieldConditionsSet_FieldCondition().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_FieldConditionsSet_FieldCondition | PlainMessage<QuickForm_FieldConditionsSet_FieldCondition> | undefined, b: QuickForm_FieldConditionsSet_FieldCondition | PlainMessage<QuickForm_FieldConditionsSet_FieldCondition> | undefined): boolean {
    return proto3.util.equals(QuickForm_FieldConditionsSet_FieldCondition, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition.Condition
 */
export class QuickForm_FieldConditionsSet_FieldCondition_Condition extends Message<QuickForm_FieldConditionsSet_FieldCondition_Condition> {
  /**
   * @generated from field: optional string field_id = 1;
   */
  fieldId?: string;

  /**
   * @generated from field: optional string val = 2;
   */
  val?: string;

  /**
   * @generated from field: string is = 3;
   */
  is = "";

  /**
   * @generated from field: optional string patient_attribute = 4;
   */
  patientAttribute?: string;

  /**
   * @generated from field: optional string reference_attribute = 5;
   */
  referenceAttribute?: string;

  /**
   * @generated from field: optional string reference_id = 6;
   */
  referenceId?: string;

  /**
   * @generated from field: optional bool is_date = 7;
   */
  isDate?: boolean;

  constructor(data?: PartialMessage<QuickForm_FieldConditionsSet_FieldCondition_Condition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition.Condition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "val", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "is", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "patient_attribute", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "reference_attribute", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "is_date", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_FieldConditionsSet_FieldCondition_Condition {
    return new QuickForm_FieldConditionsSet_FieldCondition_Condition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_FieldConditionsSet_FieldCondition_Condition {
    return new QuickForm_FieldConditionsSet_FieldCondition_Condition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_FieldConditionsSet_FieldCondition_Condition {
    return new QuickForm_FieldConditionsSet_FieldCondition_Condition().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_FieldConditionsSet_FieldCondition_Condition | PlainMessage<QuickForm_FieldConditionsSet_FieldCondition_Condition> | undefined, b: QuickForm_FieldConditionsSet_FieldCondition_Condition | PlainMessage<QuickForm_FieldConditionsSet_FieldCondition_Condition> | undefined): boolean {
    return proto3.util.equals(QuickForm_FieldConditionsSet_FieldCondition_Condition, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition.ConditionsData
 */
export class QuickForm_FieldConditionsSet_FieldCondition_ConditionsData extends Message<QuickForm_FieldConditionsSet_FieldCondition_ConditionsData> {
  /**
   * @generated from field: repeated qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition.Condition conditions = 1;
   */
  conditions: QuickForm_FieldConditionsSet_FieldCondition_Condition[] = [];

  constructor(data?: PartialMessage<QuickForm_FieldConditionsSet_FieldCondition_ConditionsData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.FieldConditionsSet.FieldCondition.ConditionsData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conditions", kind: "message", T: QuickForm_FieldConditionsSet_FieldCondition_Condition, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_FieldConditionsSet_FieldCondition_ConditionsData {
    return new QuickForm_FieldConditionsSet_FieldCondition_ConditionsData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_FieldConditionsSet_FieldCondition_ConditionsData {
    return new QuickForm_FieldConditionsSet_FieldCondition_ConditionsData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_FieldConditionsSet_FieldCondition_ConditionsData {
    return new QuickForm_FieldConditionsSet_FieldCondition_ConditionsData().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_FieldConditionsSet_FieldCondition_ConditionsData | PlainMessage<QuickForm_FieldConditionsSet_FieldCondition_ConditionsData> | undefined, b: QuickForm_FieldConditionsSet_FieldCondition_ConditionsData | PlainMessage<QuickForm_FieldConditionsSet_FieldCondition_ConditionsData> | undefined): boolean {
    return proto3.util.equals(QuickForm_FieldConditionsSet_FieldCondition_ConditionsData, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.Field
 */
export class QuickForm_Field extends Message<QuickForm_Field> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * @generated from field: repeated qliq_protobuf.LocalizedEntity label = 3;
   */
  label: LocalizedEntity[] = [];

  /**
   * FieldType field_type = 4;
   *
   * @generated from field: string field_type = 4;
   */
  fieldType = "";

  /**
   * @generated from field: string pull_from_key = 5;
   */
  pullFromKey = "";

  /**
   * @generated from field: qliq_protobuf.chat.QuickForm.Field.Config config = 6;
   */
  config?: QuickForm_Field_Config;

  /**
   * @generated from field: qliq_protobuf.chat.QuickForm.FieldConditionsSet field_conditions_set = 7;
   */
  fieldConditionsSet?: QuickForm_FieldConditionsSet;

  /**
   * @generated from field: string webhook_secret = 8;
   */
  webhookSecret = "";

  /**
   * @generated from field: string webhook_url = 9;
   */
  webhookUrl = "";

  /**
   * @generated from field: string webhook_client = 10;
   */
  webhookClient = "";

  /**
   * @generated from field: bool webhook_enabled = 11;
   */
  webhookEnabled = false;

  /**
   * @generated from field: uint32 order = 12;
   */
  order = 0;

  /**
   * @generated from field: string save_as_key = 13;
   */
  saveAsKey = "";

  constructor(data?: PartialMessage<QuickForm_Field>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.Field";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "message", T: LocalizedEntity, repeated: true },
    { no: 4, name: "field_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "pull_from_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "config", kind: "message", T: QuickForm_Field_Config },
    { no: 7, name: "field_conditions_set", kind: "message", T: QuickForm_FieldConditionsSet },
    { no: 8, name: "webhook_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "webhook_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "webhook_client", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "webhook_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "order", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 13, name: "save_as_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_Field {
    return new QuickForm_Field().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_Field {
    return new QuickForm_Field().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_Field {
    return new QuickForm_Field().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_Field | PlainMessage<QuickForm_Field> | undefined, b: QuickForm_Field | PlainMessage<QuickForm_Field> | undefined): boolean {
    return proto3.util.equals(QuickForm_Field, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.Field.Config
 */
export class QuickForm_Field_Config extends Message<QuickForm_Field_Config> {
  /**
   * @generated from field: bool is_required = 1;
   */
  isRequired = false;

  /**
   * @generated from field: bool is_enabled = 2;
   */
  isEnabled = false;

  /**
   * @generated from field: bool is_require_at_least_one = 3;
   */
  isRequireAtLeastOne = false;

  /**
   * @generated from field: bool is_default_true = 4;
   */
  isDefaultTrue = false;

  /**
   * @generated from field: bool is_numbers = 5;
   */
  isNumbers = false;

  /**
   * @generated from field: bool is_printing = 6;
   */
  isPrinting = false;

  /**
   * @generated from field: bool is_row = 7;
   */
  isRow = false;

  /**
   * @generated from field: bool is_custom_bp = 8;
   */
  isCustomBp = false;

  /**
   * @generated from field: bool is_multiple = 9;
   */
  isMultiple = false;

  /**
   * @generated from field: bool is_year_first = 10;
   */
  isYearFirst = false;

  /**
   * @generated from field: bool is_autofill = 11;
   */
  isAutofill = false;

  /**
   * @generated from field: optional int32 max = 12;
   */
  max?: number;

  /**
   * @generated from field: optional int32 min = 13;
   */
  min?: number;

  /**
   * @generated from field: optional int32 min_length = 14;
   */
  minLength?: number;

  /**
   * @generated from field: optional int32 max_length = 15;
   */
  maxLength?: number;

  /**
   * @generated from field: string format = 16;
   */
  format = "";

  /**
   * @generated from field: string first_day = 17;
   */
  firstDay = "";

  /**
   * @generated from field: repeated int32 diastolic_values = 18;
   */
  diastolicValues: number[] = [];

  /**
   * @generated from field: repeated int32 systolic_values = 19;
   */
  systolicValues: number[] = [];

  /**
   * @generated from field: repeated string accept = 20;
   */
  accept: string[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.LocalizedEntity hint = 21;
   */
  hint: LocalizedEntity[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.LocalizedEntity content = 22;
   */
  content: LocalizedEntity[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.chat.QuickForm.Field.Config.Option options = 23;
   */
  options: QuickForm_Field_Config_Option[] = [];

  /**
   * @generated from field: bool is_select_all = 24;
   */
  isSelectAll = false;

  /**
   * @generated from field: bool is_required_all_to_be_checked = 25;
   */
  isRequiredAllToBeChecked = false;

  /**
   * @generated from field: qliq_protobuf.chat.QuickForm.Field.Config.Order order_type = 26;
   */
  orderType = QuickForm_Field_Config_Order.NONE;

  /**
   * @generated from field: optional bool is_max_enabled = 27;
   */
  isMaxEnabled?: boolean;

  /**
   * @generated from field: optional bool is_min_enabled = 28;
   */
  isMinEnabled?: boolean;

  /**
   * @generated from field: optional bool is_min_length_enabled = 29;
   */
  isMinLengthEnabled?: boolean;

  /**
   * @generated from field: optional bool is_max_length_enabled = 30;
   */
  isMaxLengthEnabled?: boolean;

  constructor(data?: PartialMessage<QuickForm_Field_Config>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.Field.Config";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_require_at_least_one", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_default_true", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_numbers", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_printing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_row", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_custom_bp", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_multiple", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "is_year_first", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "is_autofill", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "max", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "min", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 14, name: "min_length", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "max_length", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 16, name: "format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "first_day", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "diastolic_values", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 19, name: "systolic_values", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 20, name: "accept", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 21, name: "hint", kind: "message", T: LocalizedEntity, repeated: true },
    { no: 22, name: "content", kind: "message", T: LocalizedEntity, repeated: true },
    { no: 23, name: "options", kind: "message", T: QuickForm_Field_Config_Option, repeated: true },
    { no: 24, name: "is_select_all", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "is_required_all_to_be_checked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 26, name: "order_type", kind: "enum", T: proto3.getEnumType(QuickForm_Field_Config_Order) },
    { no: 27, name: "is_max_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 28, name: "is_min_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 29, name: "is_min_length_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 30, name: "is_max_length_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_Field_Config {
    return new QuickForm_Field_Config().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_Field_Config {
    return new QuickForm_Field_Config().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_Field_Config {
    return new QuickForm_Field_Config().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_Field_Config | PlainMessage<QuickForm_Field_Config> | undefined, b: QuickForm_Field_Config | PlainMessage<QuickForm_Field_Config> | undefined): boolean {
    return proto3.util.equals(QuickForm_Field_Config, a, b);
  }
}

/**
 * @generated from enum qliq_protobuf.chat.QuickForm.Field.Config.Order
 */
export enum QuickForm_Field_Config_Order {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: DESC = 2;
   */
  DESC = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(QuickForm_Field_Config_Order)
proto3.util.setEnumType(QuickForm_Field_Config_Order, "qliq_protobuf.chat.QuickForm.Field.Config.Order", [
  { no: 0, name: "NONE" },
  { no: 1, name: "ASC" },
  { no: 2, name: "DESC" },
]);

/**
 * @generated from message qliq_protobuf.chat.QuickForm.Field.Config.Option
 */
export class QuickForm_Field_Config_Option extends Message<QuickForm_Field_Config_Option> {
  /**
   * @generated from field: repeated qliq_protobuf.LocalizedEntity item = 1;
   */
  item: LocalizedEntity[] = [];

  constructor(data?: PartialMessage<QuickForm_Field_Config_Option>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.Field.Config.Option";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "item", kind: "message", T: LocalizedEntity, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_Field_Config_Option {
    return new QuickForm_Field_Config_Option().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_Field_Config_Option {
    return new QuickForm_Field_Config_Option().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_Field_Config_Option {
    return new QuickForm_Field_Config_Option().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_Field_Config_Option | PlainMessage<QuickForm_Field_Config_Option> | undefined, b: QuickForm_Field_Config_Option | PlainMessage<QuickForm_Field_Config_Option> | undefined): boolean {
    return proto3.util.equals(QuickForm_Field_Config_Option, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.WebhookMapping
 */
export class QuickForm_WebhookMapping extends Message<QuickForm_WebhookMapping> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<QuickForm_WebhookMapping>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.WebhookMapping";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_WebhookMapping {
    return new QuickForm_WebhookMapping().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_WebhookMapping {
    return new QuickForm_WebhookMapping().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_WebhookMapping {
    return new QuickForm_WebhookMapping().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_WebhookMapping | PlainMessage<QuickForm_WebhookMapping> | undefined, b: QuickForm_WebhookMapping | PlainMessage<QuickForm_WebhookMapping> | undefined): boolean {
    return proto3.util.equals(QuickForm_WebhookMapping, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.Item
 */
export class QuickForm_Item extends Message<QuickForm_Item> {
  /**
   * @generated from field: uint32 position = 1;
   */
  position = 0;

  /**
   * @generated from oneof qliq_protobuf.chat.QuickForm.Item.itemable
   */
  itemable: {
    /**
     * @generated from field: qliq_protobuf.chat.QuickForm.Field field = 2;
     */
    value: QuickForm_Field;
    case: "field";
  } | {
    /**
     * @generated from field: qliq_protobuf.chat.QuickForm form = 3;
     */
    value: QuickForm;
    case: "form";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<QuickForm_Item>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.Item";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "position", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "field", kind: "message", T: QuickForm_Field, oneof: "itemable" },
    { no: 3, name: "form", kind: "message", T: QuickForm, oneof: "itemable" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_Item {
    return new QuickForm_Item().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_Item {
    return new QuickForm_Item().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_Item {
    return new QuickForm_Item().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_Item | PlainMessage<QuickForm_Item> | undefined, b: QuickForm_Item | PlainMessage<QuickForm_Item> | undefined): boolean {
    return proto3.util.equals(QuickForm_Item, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.EmrGroupConnection
 */
export class QuickForm_EmrGroupConnection extends Message<QuickForm_EmrGroupConnection> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string display_name = 3;
   */
  displayName = "";

  constructor(data?: PartialMessage<QuickForm_EmrGroupConnection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.EmrGroupConnection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_EmrGroupConnection {
    return new QuickForm_EmrGroupConnection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_EmrGroupConnection {
    return new QuickForm_EmrGroupConnection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_EmrGroupConnection {
    return new QuickForm_EmrGroupConnection().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_EmrGroupConnection | PlainMessage<QuickForm_EmrGroupConnection> | undefined, b: QuickForm_EmrGroupConnection | PlainMessage<QuickForm_EmrGroupConnection> | undefined): boolean {
    return proto3.util.equals(QuickForm_EmrGroupConnection, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.QuickForm.WorkflowOptionsByEmr
 */
export class QuickForm_WorkflowOptionsByEmr extends Message<QuickForm_WorkflowOptionsByEmr> {
  /**
   * @generated from field: uint32 emr_group_connection_id = 1;
   */
  emrGroupConnectionId = 0;

  /**
   * @generated from field: qliq_protobuf.chat.QuickForm.WorkflowOptionsByEmr.WorkflowOption workflow_option = 2;
   */
  workflowOption = QuickForm_WorkflowOptionsByEmr_WorkflowOption.DOCUMENT_TYPE_WORKFLOW;

  constructor(data?: PartialMessage<QuickForm_WorkflowOptionsByEmr>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.QuickForm.WorkflowOptionsByEmr";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "emr_group_connection_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "workflow_option", kind: "enum", T: proto3.getEnumType(QuickForm_WorkflowOptionsByEmr_WorkflowOption) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickForm_WorkflowOptionsByEmr {
    return new QuickForm_WorkflowOptionsByEmr().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickForm_WorkflowOptionsByEmr {
    return new QuickForm_WorkflowOptionsByEmr().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickForm_WorkflowOptionsByEmr {
    return new QuickForm_WorkflowOptionsByEmr().fromJsonString(jsonString, options);
  }

  static equals(a: QuickForm_WorkflowOptionsByEmr | PlainMessage<QuickForm_WorkflowOptionsByEmr> | undefined, b: QuickForm_WorkflowOptionsByEmr | PlainMessage<QuickForm_WorkflowOptionsByEmr> | undefined): boolean {
    return proto3.util.equals(QuickForm_WorkflowOptionsByEmr, a, b);
  }
}

/**
 * @generated from enum qliq_protobuf.chat.QuickForm.WorkflowOptionsByEmr.WorkflowOption
 */
export enum QuickForm_WorkflowOptionsByEmr_WorkflowOption {
  /**
   * @generated from enum value: DOCUMENT_TYPE_WORKFLOW = 0;
   */
  DOCUMENT_TYPE_WORKFLOW = 0,

  /**
   * @generated from enum value: RPA_WORKFLOW = 1;
   */
  RPA_WORKFLOW = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(QuickForm_WorkflowOptionsByEmr_WorkflowOption)
proto3.util.setEnumType(QuickForm_WorkflowOptionsByEmr_WorkflowOption, "qliq_protobuf.chat.QuickForm.WorkflowOptionsByEmr.WorkflowOption", [
  { no: 0, name: "DOCUMENT_TYPE_WORKFLOW" },
  { no: 1, name: "RPA_WORKFLOW" },
]);

